import { Suggestion } from '@/tiptap/tiptap-extensions/ai/ai-suggestion/types'
import { offset, shift, useFloating } from '@floating-ui/react'
import { Editor } from '@tiptap/core'
import { createPortal } from 'react-dom'

interface SuggestionPopoverProps {
  editor: Editor
  element: HTMLElement | null
  selectedSuggestion: Suggestion | null
}

export function SuggestionPopover({ editor, element, selectedSuggestion }: SuggestionPopoverProps) {


  // console.log('Popover debug:', {
  //   selectedSuggestion,
  //   element,
  //   allSuggestions: editor.extensionStorage.aiSuggestion.getSuggestions(),
  //   currentSelection: editor.state.selection,
  // });

  const isOpen = Boolean(element && selectedSuggestion) && (selectedSuggestion !== null)

  const { refs, floatingStyles } = useFloating({
    open: Boolean(selectedSuggestion),
    placement: 'bottom-start',
    middleware: [offset(8), shift({ padding: 8 })],
  })
  if (!isOpen) {
    return null
  }
  // React.useEffect(() => {
  //   console.log('Floating UI Debug:', {
  //     isOpen,
  //     element,
  //     selectedSuggestion,
  //     floatingStyles,
  //     referenceElement: refs.reference.current,
  //     floatingElement: refs.floating.current
  //   });
  // }, [isOpen, element, selectedSuggestion, floatingStyles, refs]);

  return (
    <>
      {element && createPortal(
        <span 
          ref={refs.setReference}
          // style={{ display: 'inline-block', width: '1px', height: '1px' }}
        />, 
        element
      )}
      {isOpen && (
        <div 
          ref={refs.setFloating} 
          style={{
            ...floatingStyles,
            position: 'fixed',
            zIndex: 9999,
          }} 
          className="bg-white rounded-lg border border-border shadow-lg p-4 space-y-2"
        >
          <h3 className="text-sm font-semibold">{selectedSuggestion.rule.title}</h3>
          <p className="text-sm">
            Replace <span className="text-red-500 line-through">{selectedSuggestion.deleteText}</span> with <span className="text-green-500">{selectedSuggestion.replacementOptions[0].addText}</span>?
          </p>
          <div className="flex gap-2">
            <button
              onClick={() => editor.commands.applyAiSuggestion({ suggestionId: selectedSuggestion.id })}
              className="px-2 py-1 text-xs bg-green-100 text-green-700 rounded hover:bg-green-200"
            >
              Accept
            </button>
            <button
              onClick={() => editor.commands.rejectAiSuggestion(selectedSuggestion.id)}
              className="px-2 py-1 text-xs bg-red-100 text-red-700 rounded hover:bg-red-200"
            >
              Reject
            </button>
          </div>
        </div>
      )}
    </>
  )
}
